import { useCallback } from 'react'
import { useDispatch, useStore } from 'react-redux'

import { authAPI } from '@/api/new-api'
import { UPDATE_BUILDING } from '@/reducers/buildingSelectorReducer'
import { Building } from '@/reducers/types'

export const getBuilding = async (id: number) => {
  const response = await authAPI.get<Building>(`/building/${id}`)
  return response.data
}

// Note: GET /building/:id does not populate luxerOneLocations, so the stored ones are kept
export const useResyncBuilding = () => {
  const dispatch = useDispatch()
  const store = useStore<{ buildingSelector: { buildings: Building[] } }>()

  return useCallback(
    async (id: number) => {
      const fresh = await getBuilding(id)
      const stored = store
        .getState()
        .buildingSelector.buildings.find((item: Building) => item.id === id)

      dispatch({
        buildingData: {
          ...stored,
          ...fresh,
          luxerOneLocations: fresh.luxerOneLocations ?? stored?.luxerOneLocations,
        },
        type: UPDATE_BUILDING,
      })
    },
    [dispatch, store],
  )
}
